<template>
  <div style="height: inherit">
    <div
      class="body-content-overlay"
      :class="{'show': mqShallShowLeftSidebar}"
      @click="mqShallShowLeftSidebar = false"
    />
    <div class="todo-app-list">
      <!-- App Searchbar Header -->
      <div class="app-fixed-search d-flex align-items-center">
        <!-- Toggler -->
        <div class="sidebar-toggle d-block d-lg-none ml-1 mt-1">
          <feather-icon
            icon="MenuIcon"
            size="21"
            class="cursor-pointer"
            @click="mqShallShowLeftSidebar = true"
          />
        </div>
      </div>

      <!-- Todo List -->
      <vue-perfect-scrollbar
        :settings="perfectScrollbarSettings"
        class="todo-task-list-wrapper list-group scroll-area p-2 h-100"
      >
        <router-view :key="$route.fullPath" />
      </vue-perfect-scrollbar>
    </div>

    <!-- Sidebar -->
    <portal to="content-renderer-sidebar-left">
      <contract-details-left-sidebar
        :mq-shall-show-left-sidebar="mqShallShowLeftSidebar"
        :class="{'show': mqShallShowLeftSidebar}"
        @close-left-sidebar="mqShallShowLeftSidebar = false"
      />
    </portal>
  </div>
</template>

<script>
import {
  BFormInput, BInputGroup, BInputGroupPrepend, BDropdown, BDropdownItem,
  BFormCheckbox,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { useResponsiveAppLeftSidebarVisibility } from '@core/comp-functions/ui/app'
import ContractDetailsLeftSidebar from '../components/ContractDetailsLeftSidebar.vue'
import * as types from '../store/types'
import { mapActions } from 'vuex'

export default {
  components: {
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BDropdown,
    BDropdownItem,
    BFormCheckbox,
    ContractDetailsLeftSidebar,
    VuePerfectScrollbar
  },
  setup() {
    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    }
    const { mqShallShowLeftSidebar } = useResponsiveAppLeftSidebarVisibility()
    return {
      perfectScrollbarSettings,
      // Left Sidebar Responsive
      mqShallShowLeftSidebar,
    }
  },
  mounted() {
    this.getDetailsGeneralInformation(this.$route.params.id)
      .catch(() => {
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Oops!",
            text: "Ocorreu um erro ao buscar as transações. Entre em contato com o setor de TI.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        this.$router.push({ name: "contracts-list" });
      });
  },
  methods: {
    ...mapActions({
      getDetailsGeneralInformation: types.GET_DETAILS_GENERAL_INFORMATION,
    })
  }
}
</script>

<style lang="scss">
@import "~@core/scss/base/pages/app-todo.scss";
@media (min-width: 769px) {
  .app-fixed-search {
    display: none !important;
  }
}
.todo-application .content-area-wrapper .content-right .app-fixed-search {
  border: none;
}
</style>
